import { render, staticRenderFns } from "./ModalShippingCombined.vue?vue&type=template&id=27330f4e&scoped=true&"
import script from "./ModalShippingCombined.vue?vue&type=script&lang=js&"
export * from "./ModalShippingCombined.vue?vue&type=script&lang=js&"
import style0 from "./ModalShippingCombined.vue?vue&type=style&index=0&id=27330f4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27330f4e",
  null
  
)

export default component.exports